const actionTypes = {
    GET_REPORTS_BY_RECON_SUCCESS: 'GET_REPORTS_BY_RECON_SUCCESS',
    GET_REPORT_FIELD_MAPPING_SUCCESS: 'GET_REPORT_FIELD_MAPPING_SUCCESS',
    GET_NEW_REPORT_FIELD_MAPPING_SUCCESS: 'GET_NEW_REPORT_FIELD_MAPPING_SUCCESS',
    GET_REPORT_RECON_MAPPINGS: 'GET_REPORT_RECON_MAPPINGS',
    GET_REPORT_RECON_FIELD_EXPRESSION: 'GET_REPORT_RECON_FIELD_EXPRESSION',
    RESET_REPORT_FIELD_MAPPING_SUCCESS: 'RESET_REPORT_FIELD_MAPPING_SUCCESS',
    GET_REPORT_SETTINGS: 'GET_REPORT_SETTINGS',
    GET_REPORT_WORKFLOW: 'GET_REPORT_WORKFLOW',
    GET_REPORT_CUSTOM_QUERY: 'GET_REPORT_CUSTOM_QUERY',
};

export default actionTypes;
